import { render } from "./PersonalitiesScienceAchievements.vue?vue&type=template&id=6a9d0fc4"
import script from "./PersonalitiesScienceAchievements.vue?vue&type=script&lang=js"
export * from "./PersonalitiesScienceAchievements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__